export const PublicRoutePath = {
  root: "/",
  login: "/login",
  register: "/register",
  buttonTest: "/button-test",
  componentDemo: "/component-demo",
  inputTest: "/input-test",
  avatarTest: "/avatar-test",
  checkboxTest: "/checkbox-test",
  radioTest: "/radio-test",
  progressTest: "/progress-test",
  toggleTest: "/toggle-test",
  dialogTest: "/dialog-test",
  modalDialogTest: "/modal-dialog-test",
  optionsMenuTest: "/options-menu-test",
  drawerModulesTest: "/drawer-modules-test",
  listItemDemo: "/list-item-demo",
  chipDemo: "/chip-demo",
  mfilterTest: "/mfilter-test",
  toastTest: "/toast-test",
  textAreaTest: "/text-area",
  progressBarTest: "/uitest/progress-bar",
  navigationBarDemo: "/navigation-bar-demo",
  profilePickerDemo: "/profile-picker-demo",
  integratedMobileDemo: "/integrated-mobile-demo",
  minfiniteScrollTest: "/minfinite-scroll",
  mframeTest: "/mframe-test",
  minfoTest: "/minfo-test",
  mbuttonCardTest: "/mbutton-card-test",
} as const;
